
import { mapState, mapActions } from 'vuex'
import productCard from '@/components/product/card'
import productHolder from '@/components/product/card/productEmpty'
import TrendGroup from '@/components/search/TrendGroup'
import SearchFilter from '@/components/search/Filter'
import dropdownSelector from '@/components/form/dropdownSelector'
import loadingMixin from '@/mixins/loading'

export default {
  name: 'Search',
  layout: 'default',

  components: {
    TrendGroup,
    productCard,
    productHolder,
    SearchFilter,
    dropdownSelector,
  },

  mixins: [loadingMixin],
  async fetch({ store, query }) {
    await store.dispatch('trend_group/product/list/getTrendGroups')
    await store.dispatch('category/list/getCategories')
    await store.dispatch('product/search/getSearchProducts', query)
  },
  data() {
    return {
      input: {
        keyword: this.$route.query.keyword ? this.$route.query.keyword : '',
        selected_group_id: this.$route.query.group ? this.$route.query.group : null,
        filter: {
          cate: [],
          loc: [],
          price_range: {
            min: '',
            max: '',
          },
          status: [],
        },
        rank: this.$route.query.rank ? this.$route.query.rank : process.env.ALGOLIA_INDEX,
        page: '',
      },
      showFilterModal: false,
      page: this.$route.query.page ? this.$route.query.page : 1,
      error_msg: '',
      breadcrumb: [
        {
          text: this.$t('route.home'),
          to: this.localePath('/'),
        },
        {
          text: this.$t('route.search'),
        },
      ],
    }
  },
  computed: {
    ...mapState('trend_group/product/list', ['trend_groups']),
    ...mapState('trend_group/city/list', ['trend_cities']),
    ...mapState('category/list', ['categories']),
    ...mapState('product/search', ['search', 'error_message']),

    rankOptions() {
      return [
        {
          id: 0,
          value: process.env.ALGOLIA_INDEX_ASC,
          txt: this.$t(`search.sort.${process.env.ALGOLIA_INDEX_ASC}`),
        },
        {
          id: 1,
          value: process.env.ALGOLIA_INDEX_DESC,
          txt: this.$t(`search.sort.${process.env.ALGOLIA_INDEX_DESC}`),
        },
        {
          id: 2,
          value: process.env.ALGOLIA_INDEX,
          txt: this.$t(`search.sort.${process.env.ALGOLIA_INDEX}`),
        },
      ]
    },

    defaultPriceRange() {
      const arr = this.search.products.map((item) => {
        return item.price_max
      })
      return {
        min: 0,
        max: Math.max(...arr),
      }
    },

    popularSearch() {
      return [
        { txt: '抹茶' },
        { txt: '餅乾' },
        { txt: '巧克力' },
        { txt: '京都和菓' },
        { txt: '大福' },
        { txt: '抹茶餅乾' },
        { txt: '茶蕨' },
        { txt: '蕨餅' },
        { txt: '年輪蛋糕' },
        { txt: '雪鹽' },
      ]
    },
  },
  watch: {
    /**
     * @description:
     */
    input: {
      handler(val) {
        const query = {
          keyword: val.keyword,
          page: val.page + 1,
          group: val.selected_group_id,
          cate: val.filter.cate.toString(),
          loc: val.filter.loc.toString(),
          fprice: val.filter.price_range.min,
          eprice: val.filter.price_range.max,
          rank: val.rank,
          status: val.filter.status.toString(),
        }

        // remove null & undefined object

        Object.keys(query).forEach((v) => !query[v] && query[v] !== undefined && delete query[v])
        this.$router.push({
          query: query,
        })
      },
      deep: true,
    },
    /**
     * @description:
     */
    '$route.query': {
      handler(val, old) {
        if (val != old) {
          //sync ui
          this.input.selected_group_id = val.group ? val.group : null
          this.input.keyword = val.keyword

          this.is_loading = true
          try {
            this.$store.dispatch('product/search/getSearchProducts', val)

            setTimeout(() => {
              this.is_loading = false
            }, 300)
          } catch (e) {
            this.error_msg = e
          }
        }
      },
    },
    page(val) {
      this.input.page = val - 1
      window.scrollTo(0, 0)
    },
    'input.filter': {
      handler() {
        this.page = 1
      },
      deep: true,
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initWishlist()
    })
    this.is_loading = false
  },

  methods: {
    ...mapActions({
      getWishlist: 'product/wishlist/getWishlist',
      resetWishlist: 'product/wishlist/resetWishlist',
    }),

    initWishlist() {
      if (this.$auth.loggedIn) {
        this.getWishlist()
      } else {
        this.resetWishlist()
      }
    },

    setSelectGroup(id) {
      this.input.selected_group_id = id
      this.input.keyword = ''

      window.scrollTo(0, 0)
    },
    handleFilter(payload) {
      this.input.filter.cate = payload.cate
      this.input.filter.loc = payload.loc
      this.input.filter.price_range.min = payload.price_range.min
      this.input.filter.price_range.max = payload.price_range.max
      this.input.filter.status = payload.status
    },
    handelRanking(payload) {
      this.input.rank = payload
    },
    resetSearch() {
      this.input.keyword = ''
      window.scrollTo(0, 0)
    },
    clickString(e) {
      this.input.keyword = e.target.dataset.value
      this.input.selected_group_id = null

      window.scrollTo(0, 0)
    },
  },
}
